<template>
	<RouterView v-if="!isSchoolSiteLoading" />
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onBeforeUnmount } from 'vue';
import { useAsyncState } from '@vueuse/core';
import { recaptcha } from '@/plugins/recaptcha';
import { useExchangeSchoolSiteService } from '@/api/exchangeSchoolSiteService';
import { useExchangeSchoolSiteStore } from '@/stores/exchangeSchoolSiteStore';
import { setTitleTag } from '@/composables/setTitleTag';
import { isApiError } from '@/api/utilities/provider';
import { useRouter } from 'vue-router';

const props = defineProps<{
	schoolSlug: string;
}>();

const router = useRouter();

const exchangeSchoolSiteService = useExchangeSchoolSiteService(props.schoolSlug);
const exchangeSchoolSiteStore = useExchangeSchoolSiteStore();

const { isLoading: isSchoolSiteLoading } = useAsyncState(
	async () => {
		try {
			const data = await exchangeSchoolSiteService.getSchool();
			if (data.publish === false) {
				router.replace({ name: 'NotFound' });
				return;
			}
			exchangeSchoolSiteStore.setSchoolSite(data);
			return data;
		} catch (error) {
			if (isApiError(error) && error.status === 404) {
				router.replace({ name: 'NotFound' });
			} else {
				console.error(error);
			}
		}
	},
	undefined,
	{ immediate: true },
);

onBeforeMount(recaptcha.load);
onBeforeUnmount(recaptcha.unload);

setTitleTag(computed(() => exchangeSchoolSiteStore.schoolSite?.exchangeFormalTitle));
</script>
